import React from "react";
import SeparadorIcon from 'src/assets/images/JM_iconos-05_linea.svg';

export const ResourceActionSeparator = () =>
{
    return <img src={SeparadorIcon} width="24px" height="24px" alt="Separador" className="icon-bar" />
}
